import { BALANCE } from '../config/balance';
import type { InputState, PlayerStats } from '../core/types';
import { initialBuild, recomputeStats } from './build';

export function xpNeeded(level: number): number {
  return BALANCE.xp.curveBase + BALANCE.xp.curveGrowth * (level - 1);
}

export class Player {
  x = 0;
  y = 0;
  prevX = 0;
  prevY = 0;
  stats: PlayerStats = recomputeStats(initialBuild());
  hp: number;
  iframes = 0;
  level = 1;
  xp = 0;
  xpToNext: number;
  /** 护盾破碎时刻（引擎时间），用于「护盾耗尽后的裸伤」归因。 */
  shieldBreakAt = -999;
  /** 最近一步实际移动方向（归一化），归因用。 */
  moveX = 0;
  moveY = 0;
  /** 本次 addXp 实际回血量（引擎读一次做表现）。 */
  lastHeal = 0;

  constructor() {
    this.hp = this.stats.maxHp;
    this.xpToNext = xpNeeded(1);
  }

  update(input: InputState, dt: number): void {
    this.prevX = this.x;
    this.prevY = this.y;
    this.moveX = input.moveX;
    this.moveY = input.moveY;
    this.x += input.moveX * this.stats.speed * dt;
    this.y += input.moveY * this.stats.speed * dt;
    if (this.iframes > 0) this.iframes -= dt;
  }

  /** 增加经验，返回触发的升级次数；每次升级回 15% 最大生命。 */
  addXp(amount: number): number {
    this.xp += amount;
    let gains = 0;
    this.lastHeal = 0;
    while (this.xp >= this.xpToNext) {
      this.xp -= this.xpToNext;
      gains++;
      this.level++;
      this.xpToNext = xpNeeded(this.level);
      const heal = this.stats.maxHp * BALANCE.heal.levelRatio;
      this.hp = Math.min(this.stats.maxHp, this.hp + heal);
      this.lastHeal += heal;
    }
    return gains;
  }

  get hpRatio(): number {
    return this.hp / this.stats.maxHp;
  }
}
